import React, { useEffect, useState, useRef, useCallback } from 'react'
import { CircularProgress, Grid, Button, Dialog, DialogContent, DialogContentText, DialogActions, Typography, Backdrop, Fade, Modal } from '@material-ui/core'
import { useSnackBar } from 'hooks/useSnackBar'
import { useArquivoService } from 'hooks/useArquivoService'
import { uniqueId } from 'lodash'
import PhotoCamera from '@material-ui/icons/PhotoCamera'
import Webcam from 'react-webcam'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import Close from '@material-ui/icons/Close'
import useStyles from './styles'

const videoConstraints = {
  width: 1280,
  height: 720,
  facingMode: 'user',
}

export const InserirArquivo = (props) => {
  const { rotaUpload, rotaLoadImagem, setFormState, formState, setProcessando, processando, tipos, disabledButton = false } = props
  const classes = useStyles()
  const snackBar = useSnackBar()
  const arquivoService = useArquivoService()
  const webcamRef = useRef(null)
  const [alertaErroTipoArquivo, setAlertaErroTipoArquivo] = useState(false)
  const [arquivosInseridos, setArquivosInseridos] = useState([])
  const [cameraImageData, setCameraImageData] = useState(null) //eslint-disable-line
  const [deletarOpen, setDeletarOpen] = useState(false)
  const [cameraOpen, setCameraOpen] = useState(false)
  const [idArquivoDeletar, setIdAquivoDeletar] = useState()
  const [processandoLeituraArquivo, setProcessandoLeituraArquivo] = useState(false)

  const fetchArquivo = async (id) => {
    try {
      const { arquivo, mimetype, nomeOriginal } = await arquivoService.listarArquivo(rotaLoadImagem, id, setProcessandoLeituraArquivo)
      setArquivosInseridos((arquivosInseridos) => [...arquivosInseridos, { data: arquivo.data, id, mimetype, nomeOriginal }])
    } catch (err) {
      console.log('erro ao tentar recuperar aquivo no ftp')
      console.log(err)
    }
  }

  useEffect(() => {
    if (formState.values.arquivos) {
      formState.values.arquivos.forEach((idArq) => {
        fetchArquivo(idArq)
      })
    }
  }, [])

  const getBase64 = (file, cb) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = function e() {
      cb(reader.result, file.name || 'upload')
    }
    reader.onerror = function ee() {
      // ignore
    }
  }

  const arrayBufferToBase64 = (buffer) => {
    let binary = ''
    const bytes = [].slice.call(new Uint8Array(buffer))
    // eslint-disable-next-line no-return-assign
    bytes.forEach((b) => (binary += String.fromCharCode(b)))
    return window.btoa(binary)
  }

  const getRawImageContent = (data) => {
    const b64 = arrayBufferToBase64(data)
    const foto = `data:image/jpeg;base64,${b64}`
    return foto
  }

  const getSrc = (data, mimetype) => {
    switch (mimetype) {
      case 'image/png': {
        return getRawImageContent(data)
      }
      case 'image/jpg': {
        return getRawImageContent(data)
      }
      case 'image/jpeg': {
        return getRawImageContent(data)
      }
      case 'application/pdf': {
        return '/images/pdf_image.png'
      }
      default:
        return '/images/pdf_image.png'
    }
  }

  function dataURItoBlob(dataURI) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    const byteString = atob(dataURI.split(',')[1])

    // separate out the mime component
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

    // write the bytes of the string to an ArrayBuffer
    const ab = new ArrayBuffer(byteString.length)
    const ia = new Uint8Array(ab)
    for (let i = 0; i < byteString.length; i += 1) {
      ia[i] = byteString.charCodeAt(i)
    }

    // write the ArrayBuffer to a blob, and you're done
    const bb = new Blob([ab], { type: mimeString })
    return bb
  }

  const handleEnviarArquivoComputador = (event) => {
    if (event.target.files[0] === undefined) return
    getBase64(event.target.files[0], async (result, filename) => {
      try {
        if (setProcessando) setProcessando(true)

        const formData = new FormData()
        const blob = dataURItoBlob(result)
        formData.append('file', blob, filename)
        const idArquivo = await arquivoService.uploadArquivo(rotaUpload, formData)

        setFormState((formState) => ({
          ...formState,
          values: {
            ...formState.values,
            arquivos: [...formState.values.arquivos, idArquivo],
          },
        }))

        fetchArquivo(idArquivo)
        if (setProcessando) setProcessando(false)
      } catch (error) {
        if (error.response.status === 415) {
          setAlertaErroTipoArquivo(true)
          setTimeout(() => {
            setAlertaErroTipoArquivo(false)
          }, 8000)
        }
      }
    })
  }

  const handleOpenDeletar = (event, idArquivo) => {
    setIdAquivoDeletar(idArquivo)
    setDeletarOpen(true)
  }

  const handleFecharDeletar = () => {
    setDeletarOpen(false)
  }

  const handleOpenCamera = () => {
    setCameraOpen(true)
  }

  const handleCloseCamera = () => {
    setCameraOpen(false)
  }

  const handleSalvarFotoCamera = useCallback(async () => {
    try {
      const formData = new FormData()
      const blob = dataURItoBlob(cameraImageData)
      formData.append('file', blob, `webcam-${new Date()}`)

      const idArquivo = await arquivoService.uploadArquivo(rotaUpload, formData)

      setFormState({
        ...formState,
        values: {
          ...formState.values,
          arquivos: [...formState.values.arquivos, idArquivo],
        },
      })

      fetchArquivo(idArquivo)
      setCameraOpen(false)
      setCameraImageData(null)
      if (setProcessando) setProcessando(false)
    } catch (error) {
      if (error.response.status === 415) {
        setAlertaErroTipoArquivo(true)
        setTimeout(() => {
          setAlertaErroTipoArquivo(false)
        }, 8000)
      }
    }
  }, [cameraImageData])

  const handleResetFotoCamera = useCallback(() => {
    setCameraImageData(null)
  }, [])

  const handleCapturarFoto = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot()
    setCameraImageData(imageSrc)
  }, [webcamRef])

  const handleDeletarArquivo = async () => {
    if (setProcessando) setProcessando(true)

    await arquivoService.deletarArquivo(rotaUpload, idArquivoDeletar)
    const index = formState.values.arquivos.indexOf(idArquivoDeletar)
    const arrayArquivoDeletado = formState.values.arquivos
    arrayArquivoDeletado.splice(index, 1)
    setFormState({
      ...formState,
      values: {
        ...formState.values,
        arquivos: arrayArquivoDeletado,
      },
    })
    const novosArquivosInseridos = arquivosInseridos
    novosArquivosInseridos.splice(index, 1)
    setArquivosInseridos(novosArquivosInseridos)
    handleFecharDeletar()
    if (setProcessando) setProcessando(false)
  }

  const definirTiposAceitos = (tipos) => {
    let t = ''
    tipos.forEach((tipo) => {
      switch (tipo) {
        case 'image':
          t += 'image/png,image/jpg,image/jpeg,'
          break
        case 'pdf':
          t += 'application/pdf,'
          break
        default:
          break
      }
    })
    return t
  }

  return (
    <div>
      {processando ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <Grid alignItems="center" container justify="flex-start">
          {processandoLeituraArquivo ? (
            <div className={classes.carregando}>
              <CircularProgress disableShrink />
            </div>
          ) : (
            <Grid item container md={12} sm={12} xs={12}>
              {arquivosInseridos.map((arquivo) => (
                <Grid key={uniqueId()} className={classes.arquivos} item md={3} sm={6} xs={12}>
                  {arquivo.mimetype !== 'image/png' && arquivo.mimetype !== 'image/jpg' && arquivo.mimetype !== 'image/jpeg' ? <img src={getSrc(arquivo.data, arquivo.mimetype)} width="60%" spacing={2} alt="" /> : <img src={getSrc(arquivo.data, arquivo.mimetype)} width="80%" spacing={2} alt="" />}

                  <Typography>{arquivo.nomeOriginal}</Typography>
                  <Button key={uniqueId()} variant="outlined" color="primary" size="small" className={(classes.button, classes.margin)} onClick={(e) => handleOpenDeletar(e, arquivo.id)} endIcon={<Close />}>
                    Remover
                  </Button>
                </Grid>
              ))}
            </Grid>
          )}

          <Grid className={classes.alert} item md={12} sm={12} xs={12}>
            {alertaErroTipoArquivo &&
              snackBar({
                variant: 'error',
                message: 'Tipo de arquivo não suportado. Selecione um arquivo compatível',
              })}
          </Grid>
          <Grid className={classes.item} item md={12} sm={12} xs={12}>
            <Grid className={classes.fieldGroup} item md={5} sm={8} xs={12}>
              {tipos.includes('image') && (
                <Button style={{ backgroundColor: '#474554', color: 'white' }} size="small" variant="contained" startIcon={<PhotoCamera />} onClick={handleOpenCamera} disabled={disabledButton}>
                  Usar Câmera
                </Button>
              )}

              <Button variant="contained" style={{ backgroundColor: '#474554', color: 'white' }} size="small" component="label" startIcon={<CloudUploadIcon />}>
                Enviar arquivo
                <input accept={definirTiposAceitos(tipos)} className={classes.enviarArquivoComputador} id="enviarArquivoComputador" name="arquivos" type="file" hidden onChange={handleEnviarArquivoComputador} />
              </Button>
            </Grid>
          </Grid>

          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={cameraOpen}
            onClose={handleCloseCamera}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={cameraOpen}>
              <div className={classes.paper}>
                {cameraImageData ? (
                  <div>
                    <div>
                      <img src={cameraImageData} width="100%" alt="" />
                    </div>
                    <div className={classes.fieldGroup}>
                      <Button color="primary" variant="outlined" onClick={handleSalvarFotoCamera}>
                        Salvar foto
                      </Button>
                      <Button color="secondary" variant="outlined" onClick={handleResetFotoCamera}>
                        Refazer foto
                      </Button>
                      <Button color="primary" variant="outlined" onClick={handleCloseCamera}>
                        Fechar
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div>
                      <Webcam audio={false} height="100%" width="100%" minScreenshotWidth={1920} minScreenshotHeight={1080} ref={webcamRef} screenshotFormat="image/jpeg" videoConstraints={videoConstraints} />
                    </div>

                    <div>
                      <Button color="secondary" variant="outlined" onClick={handleCapturarFoto}>
                        Capturar foto
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </Fade>
          </Modal>

          <Dialog open={deletarOpen} onClose={handleFecharDeletar} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
            <DialogContent>
              <DialogContentText id="alert-dialog-description">Tem certeza que deseja remover o arquivo?</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleFecharDeletar} color="primary">
                Não
              </Button>
              <Button disabled={processando} onClick={handleDeletarArquivo} variant="outlined" color="secondary" autoFocus>
                Sim
                {processando && <CircularProgress size={24} className={classes.buttonProgress} />}
              </Button>
            </DialogActions>
          </Dialog>
        </Grid>
      )}
    </div>
  )
}
